export function getEmailInfo(email: string) {
  const [local, domain] = email.split('@');

  return {
    full: email,
    local,
    domain,
  };
}
